import React from 'react';
import Text from '../basic/Text';
import HTMLWrapper from "../basic/HTMLWrapper"
import documentToReactComponents from "../../components/util/documentToReactComponents"
import styled from "styled-components"


const SubTitleStyle = styled(HTMLWrapper)`
    p:not([class^='Body']):not([class^='AllCaps'])  {
        font-size: 14px;
    }
`
 
const SmallCallout = ({ smallCalloutTitle, smallCalloutSubtitle, additionalText }) => {
    const subtitle = smallCalloutSubtitle.childMarkdownRemark.html
    return (
        <>
            <Text component="caps">{smallCalloutTitle}</Text>
            <SubTitleStyle html={subtitle} />
            {documentToReactComponents(additionalText)}

        </>
    )
}
 
export default SmallCallout